import { render } from "./error_gserver.vue?vue&type=template&id=3de8f872"
import script from "./error_gserver.vue?vue&type=script&lang=js"
export * from "./error_gserver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__